import { Api } from "laravel-request";

import { DELETED, UNCLASSIFIED } from "#app/constants/learnCategories";

export interface LearnCategory {
    id: number | string;
    name: string;
    parent_id?: number | null;
    order?: number;
    children?: LearnCategory[];
}

export interface LearnFile {
    id: number;
    name?: string;
    categories?: LearnCategory[];
    [key: string]: any;
}

export const getFiles = (callback: (data: LearnFile[]) => void) => {
    Api.get("crm-file", "index")
        .with("categories")
        .all(({ data }: { data: LearnFile[] }) => callback(data));
};

export const getCategories = (
    setCategories: (categories: LearnCategory[]) => void,
    setSelectedCategory?: (category: LearnCategory) => void
) => {
    Api.get("crm-category", "index")
        .whereNull("parent_id")
        .orderBy("order")
        .with("children.children")
        .all(({ data }: { data: LearnCategory[] }) => {
            const updatedCategories: LearnCategory[] = [
                ...data,
                { id: UNCLASSIFIED, name: "Неразобранные" },
                { id: DELETED, name: "Архив" },
            ];
            setCategories(updatedCategories);
            if (setSelectedCategory && updatedCategories.length > 0) {
                setSelectedCategory(updatedCategories[0]);
            }
        });
};

export const downloadFile = (fileId: number, filename: string) => {
    const url = `${process.env.REACT_APP_API_URL}/api/v1/call/crm-file/file?data[file_id]=${fileId}`;
    const token = localStorage.getItem("api_token");

    fetch(url, {
        method: "GET",
        headers: { Authorization: token || "" },
        keepalive: true,
    })
        .then((response) => response.blob())
        .then((blob) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
        })
        .catch((error: any) => console.error("Error:", error));
};

export const toggleFileDelete = (fileId: number, callback?: () => void) => {
    Api.post("crm-file", "toggle-delete", {
        file_id: fileId,
    }).call(() => {
        callback?.();
    });
};
